import * as Yup from "yup";

/** Used by UpiSection — validates UPI ID (VPA) format */
export const VpaSchema = Yup.object({
  custVpa: Yup.string()
    .required("UPI ID is required")
    .matches(
      /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{3,64}$/,
      "Enter a valid UPI ID (e.g. name@upi)"
    ),
});

/** Used by CardSection — validates credit/debit card fields.
 *  NOTE: cardNumber is managed in separate React state (not a Formik field),
 *  so it is intentionally excluded from this schema.
 */
export const CardSchema = Yup.object({
  cardName:   Yup.string().required("Cardholder name is required"),
  expiry:     Yup.string()
                .required("Expiry date is required")
                .matches(/^\d{2}\/\d{2}$/, "Use MM/YY format"),
  cvv:        Yup.string()
                .required("CVV is required")
                .min(3, "CVV must be 3-4 digits")
                .max(4, "CVV must be 3-4 digits"),
});
